__turbopack_context__.v({
  "Body": "LLfKBW_Body",
  "Categories": "LLfKBW_Categories",
  "CategoriesLabel": "LLfKBW_CategoriesLabel",
  "Chip": "LLfKBW_Chip",
  "ChipActive": "LLfKBW_ChipActive",
  "Chips": "LLfKBW_Chips",
  "ClearAll": "LLfKBW_ClearAll",
  "Count": "LLfKBW_Count",
  "List": "LLfKBW_List",
  "Main": "LLfKBW_Main",
  "Reports": "LLfKBW_Reports",
  "Root": "LLfKBW_Root",
  "Summary": "LLfKBW_Summary",
  "SummaryText": "LLfKBW_SummaryText",
  "Toolbar": "LLfKBW_Toolbar",
  "skeleton-loading": "LLfKBW_skeleton-loading",
});
